export interface EnumVariant {
  description?: string;
  id?: number;
  name?: string;
  variant_name?: string;
  state?: 'active' | 'deprecated' | 'disabled';
}

export enum TagState {
  Active = 'active',
  Deprecated = 'deprecated',
  Disabled = 'disabled',
}

/**
 * Used to represent questions for events
 */
export interface Tag {
  description: string;
  name: string;
  value_type: 'int' | 'bool' | 'enum';
  is_rare: boolean;
  is_internal: boolean;
  is_global: boolean;
  fleet_uuids?: string[];
  enum_variants?: EnumVariant[];
  id?: any;
  max_value?: number;
  min_value?: number;
  state?: TagState;
}

/**
 * Used to store answers for events
 */
export interface Tags {
  [key: string]: string | number | boolean;
}
